"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _NotificationsPollService = _interopRequireDefault(require("./service/NotificationsPollService"));

var _TimelineService = _interopRequireDefault(require("./service/TimelineService"));

var _NotificationsConfigFetcher = _interopRequireDefault(require("./service/NotificationsConfigFetcher"));

var _SettingsService = _interopRequireDefault(require("./service/SettingsService"));

var _store = _interopRequireDefault(require("./store/store"));

var _AnnouncementLongPoll = _interopRequireDefault(require("./service/AnnouncementLongPoll"));

var NotificationSelectors = _interopRequireWildcard(require("../pulse/store/reducers/NotificationReducer"));

var types = _interopRequireWildcard(require("./store/actions/actionTypes"));

var _AppAssemblyResponseParser = _interopRequireDefault(require("./service/AppAssemblyResponseParser"));

var NotificationsActions = _interopRequireWildcard(require("./store/actions/actions"));

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/
var PulseWrapper =
/*#__PURE__*/
function () {
  function PulseWrapper() {
    (0, _classCallCheck2.default)(this, PulseWrapper);
    this.isPulseInitied = false;
  }

  (0, _createClass2.default)(PulseWrapper, [{
    key: "initPulse",
    value: function () {
      var _initPulse = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(accessToken, imsOrg) {
        var env,
            locale,
            appAssemblyResponse,
            settingsService,
            viewAll,
            timelineData,
            settingsData,
            payload,
            userEntitlementsPayload,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                env = _args.length > 2 && _args[2] !== undefined ? _args[2] : 'dev';
                locale = _args.length > 3 ? _args[3] : undefined;
                appAssemblyResponse = _args.length > 4 ? _args[4] : undefined;
                settingsService = _args.length > 5 ? _args[5] : undefined;
                viewAll = _args.length > 6 && _args[6] !== undefined ? _args[6] : false;
                timelineData = _args.length > 7 && _args[7] !== undefined ? _args[7] : {};
                settingsData = _args.length > 8 && _args[8] !== undefined ? _args[8] : {};
                this.metrics = _metrics.default.create('exc.pulse.PulseWrapper');
                this.timer = this.metrics.start();
                payload = {
                  accessToken: accessToken,
                  activeIMSOrg: imsOrg,
                  locale: locale,
                  environment: env
                };
                window.store = _store.default;
                this.appAssemblyResponseParser = new _AppAssemblyResponseParser.default(); // init ExC Settings service

                (0, _SettingsService.default)({
                  settingsService: settingsService,
                  viewAll: viewAll
                });
                userEntitlementsPayload = this.appAssemblyResponseParser.getUserEntitlementsFromAppAssemblyResponse(appAssemblyResponse);
                _context.next = 16;
                return _store.default.dispatch({
                  type: types.FETCHED_USER_ENTITLEMENTS,
                  userEntitlementsPayload: userEntitlementsPayload
                });

              case 16:
                _context.next = 18;
                return _store.default.dispatch({
                  type: types.NOTIFICATIONS_CONFIG_FETCHED,
                  payload: payload
                });

              case 18:
                _context.next = 20;
                return this.fetchDataAndUpdateStore(viewAll, timelineData, settingsData);

              case 20:
                _NotificationsPollService.default.fetchNotificationsData(_store.default);

                _AnnouncementLongPoll.default.fetchAnnouncementsData(_store.default);

                this.isPulseInitied = true;
                this.timer.time("exc.pulse.initiated");

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initPulse(_x, _x2) {
        return _initPulse.apply(this, arguments);
      }

      return initPulse;
    }()
  }, {
    key: "fetchDataAndUpdateStore",
    value: function () {
      var _fetchDataAndUpdateStore = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(isViewAll) {
        var timelineData,
            settingsData,
            _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                timelineData = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
                settingsData = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
                this.timelineService = new _TimelineService.default();
                this.NotificationConfigFetcher = new _NotificationsConfigFetcher.default();

                if (!isViewAll) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 7;
                return Promise.all([this.updateUserSettings(), this.timelineService.fetchTimeline(_store.default), this.NotificationConfigFetcher.fetchConfigData(_store.default)]);

              case 7:
                _context2.next = 9;
                return _store.default.dispatch(NotificationsActions.fetchFilteredNotifications('', ''));

              case 9:
                _context2.next = 13;
                break;

              case 11:
                _context2.next = 13;
                return Promise.all([this.updateUserSettings(settingsData), this.timelineService.fetchTimeline(_store.default, {}, timelineData)]);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchDataAndUpdateStore(_x3) {
        return _fetchDataAndUpdateStore.apply(this, arguments);
      }

      return fetchDataAndUpdateStore;
    }()
  }, {
    key: "updateUserSettings",
    value: function () {
      var _updateUserSettings = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3() {
        var settingsData,
            userSettings,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                settingsData = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
                _context3.next = 3;
                return (0, _SettingsService.default)().getUserSettings(settingsData);

              case 3:
                userSettings = _context3.sent;

                if (!userSettings) {
                  _context3.next = 14;
                  break;
                }

                if (!('lastClickTimestamp' in userSettings)) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 8;
                return _store.default.dispatch({
                  type: types.SET_LAST_USER_CLICK_TIMESTAMP,
                  payload: userSettings.lastClickTimestamp
                });

              case 8:
                if (!('lastSeenAnnouncementsTimestamp' in userSettings)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 11;
                return _store.default.dispatch({
                  type: types.SET_LAST_ANNOUNCEMENT_TS,
                  payload: {
                    'lastSeenTimestamp': userSettings.lastSeenAnnouncementsTimestamp
                  }
                });

              case 11:
                if (!('lastNotificationSeenTimestamp' in userSettings)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 14;
                return _store.default.dispatch({
                  type: types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP,
                  payload: userSettings.lastNotificationSeenTimestamp
                });

              case 14:
                this.timer.time("exc.pulse.userSettingsUpdated");

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function updateUserSettings() {
        return _updateUserSettings.apply(this, arguments);
      }

      return updateUserSettings;
    }()
  }, {
    key: "handleIMSOrgChange",
    value: function () {
      var _handleIMSOrgChange = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(imsOrg, appAssemblyResponse) {
        var viewAll,
            activeIMSOrg,
            payload,
            userEntitlementsPayload,
            _args4 = arguments;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                viewAll = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : false;
                activeIMSOrg = NotificationSelectors.getActiveIMSOrg(_store.default.getState());

                if (!(activeIMSOrg !== imsOrg)) {
                  _context4.next = 15;
                  break;
                }

                payload = {
                  activeIMSOrg: imsOrg
                };
                this.appAssemblyResponseParser = new _AppAssemblyResponseParser.default();
                userEntitlementsPayload = this.appAssemblyResponseParser.getUserEntitlementsFromAppAssemblyResponse(appAssemblyResponse);
                _context4.next = 8;
                return _store.default.dispatch({
                  type: types.ACTIVE_IMS_ORG_CHANGED,
                  payload: payload
                });

              case 8:
                _context4.next = 10;
                return _store.default.dispatch({
                  type: types.FETCHED_USER_ENTITLEMENTS,
                  userEntitlementsPayload: userEntitlementsPayload
                });

              case 10:
                _context4.next = 12;
                return this.fetchDataAndUpdateStore(viewAll);

              case 12:
                _AnnouncementLongPoll.default.fetchAnnouncementsData(_store.default);

                _NotificationsPollService.default.fetchNotificationsData(_store.default);

                this.timer.time("exc.pulse.orgChanged");

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function handleIMSOrgChange(_x4, _x5) {
        return _handleIMSOrgChange.apply(this, arguments);
      }

      return handleIMSOrgChange;
    }()
  }, {
    key: "isPulseReady",
    value: function isPulseReady() {
      return this.isPulseInitied;
    }
  }]);
  return PulseWrapper;
}();

var _default = new PulseWrapper();

exports.default = _default;